import React from 'react';
import { Text, Pressable, ViewStyle } from 'react-native';
import Icon from 'LocalGluons/components/Icon';
import defaultStyles from './styles';

interface BigButtonProps {
    iconName: string;
    heading: string;
    description?: string;
    style?: { button: ViewStyle; icon: ViewStyle; heading: ViewStyle; description: ViewStyle };
    onPress?: () => void;
}

const BigButton = ({
    iconName,
    heading,
    description = null,
    style,
    onPress
}: BigButtonProps): React.ReactElement => (
    <Pressable style={[defaultStyles.button, style?.button]} onPress={onPress}>
        <Icon name={iconName} style={[defaultStyles.icon, style?.icon]} />
        <Text style={[defaultStyles.heading, style?.heading]} numberOfLines={2}>
            {heading}
        </Text>
        {description && (
            <Text style={[defaultStyles.description, style?.description]}>{description}</Text>
        )}
    </Pressable>
);

export default BigButton;
